import { Form } from "@redriver/cinnamon-mui";
import { contactMethodLookup } from "modules/lookups";

const ContactMethodDropdown = (props) => (
  <Form.Dropdown lookup={contactMethodLookup} {...props} />
);

export default ContactMethodDropdown;
